import { Client } from "@/redux/slices/client/types";
import { ClientsOptions } from "@/redux/slices/client/types";
import { GetClientOptionsRawResponse, GetClientsRawResponse, GetClientsResponse } from "./types";

export const transformClients = (res: GetClientsRawResponse) => {
  const {
    _embedded: { client: clients },
    page,
    page_count,
    page_size,
    total_items,
  } = res;

  const response: GetClientsResponse = {
    data: {
      clients: clients.map(
        (i) =>
          ({
            id: i.uuid,
            name: i.name,
            email: i.email,
            phone: i.phone,
            companyId: i.company?.uuid,
            companyName: i.company?.name,
            accountType: i.account_type,
            hearAboutUs: i.hear_about_us,
            status: i.status,
            joined: i.join_date,
          } as Client)
      ),
      page: {
        current: page,
        count: page_count,
        size: page_size,
        total: total_items,
      },
    },
  };

  return response;
};

export const transformClientOptions = (res: GetClientOptionsRawResponse) => {
  const { status, account_type } = res;

  const response: ClientsOptions = {
    statuses: Object.entries(status).map((i) => ({ name: i[1], value: i[0] })),
    types: Object.entries(account_type).map((i) => ({ name: i[1], value: i[0] })),
  };

  return response;
};
